import { UseTableInstanceProps } from 'react-table';
import { protectCustomColumn } from 'utils/typeGuards';
import styles from './TableHeader.module.css';

const TableHeader = <D extends object>({
  headerGroups,
}: Pick<UseTableInstanceProps<D>, 'headerGroups'>) => (
  <thead className={styles.header}>
    {headerGroups.map((headerGroup) => {
      const { key: headerGroupKey, ...headerGroupProps } =
        headerGroup.getHeaderGroupProps();

      return (
        <tr key={headerGroupKey} {...headerGroupProps}>
          {headerGroup.headers.map((column) => {
            const { key: headerKey, ...headerProps } = column.getHeaderProps();

            return (
              <th
                key={headerKey}
                {...headerProps}
                className={protectCustomColumn(column)?.className}
              >
                {column.render('Header')}
              </th>
            );
          })}
        </tr>
      );
    })}
  </thead>
);

export default TableHeader;
